module.exports = __webpack_public_path__ + "img/logo5-blue-white-gold-fill.20e3b825.svg";